<div class="flex flex-col text-center">
	<h4>Are you sure you would like to cancel this mortgage intake?</h4>
	<p>This is a permanent action and your work will be undone.</p>
</div>

<div class="flex justify-between mt-10">
	<app-button btn="border" class="mr-5" (click)="onKeep()">Keep</app-button>
	<app-button btn="error" (click)="onCancel()">Cancel</app-button>
</div>
